import React from 'react';

import { MaybeUndef } from '../../../../types/system';
import { OperationStatus } from '../../operation-groups/operation-groups.types';
import { OperationAction } from '../../operation-panel.types';

import { HoverActionButton } from './hover-action-button/hover-action-button';
import { NonHoverStatus } from './non-hover-status/non-hover-status';
import styles from './operation-status-presentation.scss';

interface Props {
  status: OperationStatus;
  progress?: number;
  onLocateClick?(): void;
  onRetryClick?(): void;
  onCancelClick?(): void;
  cancelButtonHint?: string;
}

interface State {
  showAction: MaybeUndef<OperationAction>;
}

export class OperationStatusPresentation extends React.Component<Props, State> {
  public state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      showAction: undefined,
    };
  }

  private showLocate() {
    this.setState({ showAction: OperationAction.Locate });
  }

  private showCancel() {
    this.setState({ showAction: OperationAction.Cancel });
  }

  private showRetry() {
    this.setState({ showAction: OperationAction.Retry });
  }

  private hideAction() {
    this.setState({ showAction: undefined });
  }

  public render() {
    const {
      progress,
      status,
      onLocateClick,
      onCancelClick,
      onRetryClick,
      cancelButtonHint,
    } = this.props;
    const { showAction } = this.state;
    let showActionHandler;

    if (status === OperationStatus.Succeeded && onLocateClick) {
      showActionHandler = this.showLocate.bind(this);
    } else if (status === OperationStatus.InProgress && onCancelClick) {
      showActionHandler = this.showCancel.bind(this);
    } else if (status === OperationStatus.Failed && onRetryClick) {
      showActionHandler = this.showRetry.bind(this);
    }

    return (
      <div
        className={styles.operationStatusPresentation}
        onMouseEnter={showActionHandler}
        onMouseLeave={
          showActionHandler ? this.hideAction.bind(this) : undefined
        }
      >
        {showAction ? (
          <HoverActionButton
            action={showAction}
            onLocateClick={onLocateClick}
            onRetryClick={onRetryClick}
            onCancelClick={onCancelClick}
            cancelButtonHint={cancelButtonHint}
          />
        ) : (
          <NonHoverStatus status={status} progress={progress} />
        )}
      </div>
    );
  }
}
